import './styles.css';
import PropTypes from 'prop-types';
import React from 'react';
import onClickOutside from 'react-onclickoutside';
import { NavLink } from 'react-router-dom';
import Avatar from '../../../../../../components/Avatar';
import ROUTE from '../../../../../../constants/route';
import { UPGRADE_ACCOUNT_TYPE } from '../../../../../../constants/upgrade-account-types';
import UpgradeRecruiterAccount from '../../../../../Dialog/components/UpgradeRecruiterAccount';

class ProfileDropdown extends React.Component {
  clickHandler = e => {
    e.stopPropagation();
    this.props.toggleFunc('profile');
  };

  handleClickOutside = () => {
    this.props.toggleFunc('outsideProf');
  };

  render() {
    const { avatar, name, accountType } = this.props;
    const subMenuStatus = this.props.toggled ? 'flex' : 'none';
    const subMenuStyles = {
      display: subMenuStatus,
    };

    const menu = [
      {
        name: 'Account Settings',
        to: ROUTE.CANDIDATE_ACCOUNT,
      },
      {
        name: 'Upgrade Account',
        to: ROUTE.CANDIDATE_UPGRADE_PREMIUM,
        controlFunc:
          this.props.upgradeLink &&
          this.props.upgradeType === UPGRADE_ACCOUNT_TYPE.RECRUITER
            ? () => {
                this.handleClickOutside();
                UpgradeRecruiterAccount();
              }
            : null,
      },
      {
        name: 'Logout',
        href: ROUTE.LOGOUT,
      },
    ].filter(link =>
      this.props.upgradeLink
        ? true
        : link.to !== ROUTE.CANDIDATE_UPGRADE_PREMIUM
    );

    return (
      <div className="profile-dropdown">
        <div
          className={'profile-dropdown__trigger'}
          onClick={this.clickHandler}
        >
          <div className="profile-dropdown__profile-pic">
            {!!avatar && <Avatar size={32} name={name} image={avatar} />}
            {!avatar && (
              <span className={'profile-dropdown__avatar'}>
                <svg
                  aria-hidden="true"
                  fill="none"
                  height="28px"
                  role="presentation"
                  viewBox="0 0 24 24"
                  width="28px"
                >
                  <path
                    d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M17.0809 14.1489C14.2909 12.2889 9.74094 12.2889 6.93094 14.1489C5.66094 14.9989 4.96094 16.1489 4.96094 17.3789C4.96094 18.6089 5.66094 19.7489 6.92094 20.5889C8.32094 21.5289 10.1609 21.9989 12.0009 21.9989C13.8409 21.9989 15.6809 21.5289 17.0809 20.5889C18.3409 19.7389 19.0409 18.5989 19.0409 17.3589C19.0309 16.1289 18.3409 14.9889 17.0809 14.1489Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
            )}
          </div>
          <span className="profile-dropdown__icon">
            <svg width="8" height="8" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 5.97 1.17 3.14l.76-.76L4 4.45l2.07-2.07.76.76L4 5.97Z"
                fill="#030330"
              />
            </svg>
          </span>
        </div>
        <div
          className="profile-dropdown__submenu ignore-react-onclickoutside"
          style={subMenuStyles}
        >
          <div className={'profile-dropdown__submenu-header'}>
            <p className="profile-dropdown__name">{name}</p>
            <p className="profile-dropdown__message">{accountType}</p>
          </div>
          <ul className="profile-dropdown__submenu-list">
            {menu.map((item, index) => (
              <li className="profile-dropdown__submenu-list-item" key={index}>
                {item.controlFunc ? (
                  <div
                    className="profile-dropdown__submenu-link"
                    onClick={item.controlFunc}
                  >
                    {item.name}
                  </div>
                ) : item.to ? (
                  <NavLink
                    to={item.to}
                    className="profile-dropdown__submenu-link"
                    onClick={this.handleClickOutside}
                  >
                    {item.name}
                  </NavLink>
                ) : (
                  <a
                    href={item.href}
                    className="profile-dropdown__submenu-link"
                  >
                    {item.name}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

ProfileDropdown.propTypes = {
  toggled: PropTypes.bool.isRequired,
  toggleFunc: PropTypes.func.isRequired,
  avatar: PropTypes.string,
  name: PropTypes.string,
  upgradeLink: PropTypes.bool,
  upgradeType: PropTypes.string,
  accountType: PropTypes.string,
};

export default onClickOutside(ProfileDropdown);
